import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
function FiltroMeses({
	mesesSeleccionados,
	setMesesSeleccionados,
	mesesFiltrados,
	optionsLoading,
}) {
	const { t } = useTranslation();
	const handleChange = (event) => {
		const { value } = event.target;
		setMesesSeleccionados(typeof value === "string" ? value.split(",") : value);
	};

	return (
		<FormControl fullWidth variant="outlined">
			<InputLabel id="label-meses">{t("new_charts.months")}</InputLabel>
			<Select
				fullWidth
				size="small"
				labelId="label-meses"
				multiple
				value={mesesSeleccionados}
				onChange={handleChange}
				label={t("new_charts.months")}
				renderValue={(selected) =>
					selected.map((value) => mesesFiltrados.find((mes) => mes.value === value)?.label).join(", ")
				}
			>
				{optionsLoading ? (
					<MenuItem disabled>{t("new_charts.loading")}</MenuItem>
				) : (
					mesesFiltrados.map((mes) => (
						<MenuItem key={mes.value} value={mes.value}>
							<Checkbox checked={mesesSeleccionados.includes(mes.value)} />
							<ListItemText primary={mes.label} />
						</MenuItem>
					))
				)}
			</Select>
		</FormControl>
	);
}

export { FiltroMeses };
